export const MUTATION_DELETE_MM_CASE = /* GraphQL */ `
	mutation ($id: String!) {
		deleteMietminderungCase(id: $id)
	}
`;
